/** Custom domain mapped to the Buxus Azure storage account (same path + SAS query). */
export const BUXUS_CONTENT_BLOB_HOST = 'content.buxus.io'

/**
 * Rewrites a raw Azure Blob Storage URL to the content.buxus.io custom domain.
 * Leaves non-blob URLs unchanged. Path and SAS query string are preserved.
 */
export function rewriteAzureBlobUrlToContentDomain(url: string): string {
  if (!url) {
    return url
  }

  try {
    const parsed = new URL(url)
    if (parsed.hostname.endsWith('.blob.core.windows.net')) {
      parsed.hostname = BUXUS_CONTENT_BLOB_HOST
      return parsed.toString()
    }
  } catch {
    // Invalid URL — return as-is
  }

  return url
}
